import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
// 获取技术需求
export function getFrontList(params, data) {
  const url = handlerGetUrlParams('/bus/demands/home/list', params)
  return request({
    url,
    method: 'POST',
    data
  })
}
export function hotTag() {
  return request({
    url: '/bus/demands/hotTag',
    method: 'GET'
  })
}

export function demandId(id) {
  return request({
    url: '/bus/demands/home/' + id,
    method: 'GET'
  })
}
export function isView(id) {
  return request({
    url: '/bus/demands/is_view/' + id,
    method: 'PUT'
  })
}

export function infoList(params) {
  return request({
    url: '/bus/info/frontList',
    method: 'POST',
    params
  })
}

export function previewFile(id) {
  return request({
    url: '/bus/info/previewFile_' + id,
    method: 'GET'
  })
}
